<template>
  <div ref="jsonEditor" id="json-editor"></div>
</template>

<script>
import { JSONEditor } from '@json-editor/json-editor';

export default {
  name: 'VpJsonEditor',
  props: {
    schema: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() { 
    return { editor: {} };
  },
  watch: {
    disabled() {
      this.updated();
    },
  },
  async mounted() {
    const options = { 
      schema: this.schema, 
      display_required_only: false,
      no_additional_properties: false,
      disable_collapse: true,
      disable_array_delete_all_rows: true,
      disable_array_delete_last_row: true,
      template: 'underscore',
      disable_properties: true,
      show_opt_in: true,
    }
    if (this.value) options.startval = this.value

    this.editor = await new JSONEditor(this.$refs.jsonEditor, options);
    setTimeout(() => { this.updated(); }, 1);
    
    this.editor.on('change',() => {
      this.$emit('input', this.editor.getValue());
      this.updated();
    });
  },
  methods: {
    updated() {
      if (this.disabled === true) this.editor.disable();
      else this.editor.enable();
      this.colorInitialTabs()
      this.$emit('updated');
    },
    colorActiveTab(e) {
      e.currentTarget.classList.remove('inactive-tab');
      e.currentTarget.classList.add('active-tab');
      ['nextSibling', 'previousSibling'].forEach(siblingType => {
        let sibling = e.currentTarget[siblingType];
        while (sibling) {
          sibling.classList.remove('active-tab');
          sibling.classList.add('inactive-tab');
          sibling = sibling[siblingType];
        }
      });
    },
    colorInitialTabs() {
      [...document.querySelectorAll('.je-tab--top')].forEach(tab => {
        tab.classList.remove('inactive-tab');
        tab.classList.remove('active-tab');
        tab.addEventListener('click', this.colorActiveTab);
        if (tab.style.opacity === '1') tab.classList.add('active-tab');
        else tab.classList.add('inactive-tab');
      });
    }
  },
};
</script>

<style lang="scss">
#json-editor {
  div[data-schemaid="root"]{
    &>h3 {
     display: none; 
    }
  }
  button {
    padding: 3px 7px;
    margin-right: 5px;
    border-radius: 5px !important;
    border: 2px solid #008CBA;
    background-color: #fff;
    color: #008CBA;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;

    &.json-editor-btn-delete.delete.json-editor-btntype-delete {
      border: 2px solid red;
      color: red;
    }
  }
  .je-indented-panel {
    border: 0px;
  }
  .je-tabholder--clear {
    border: 1px solid #dee2e6
  }
  .je-tabholder--top {
    display: flex;
    flex-wrap: wrap;
    margin: 0px;
    padding: 8px 8px 0px 8px;
    border: 1px solid #dee2e6;
    border-bottom-width: 0px;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba($color: #000000, $alpha: .024);

    .je-tab--top {
      margin-bottom: -1px;
      padding: 8px 16px;
      font-weight: 400;
      border-bottom: 1px solid #cccccc;

      &.active-tab {
        color: #008CBA;
      }
      &.inactive-tab {
        color: #000000;
        opacity: 1 !important;
      } 
    }
  }
  h3.je-header {
    height: auto;
    margin: 0px 0px 10px 0px;

    label {
      display: inline;
      font-size: 28px;
      font-weight: 500;
    }
    &.je-object__title {
      margin-left: 15px;
    }
    & ~ .je-indented-panel {
      margin-top: 0px;
    }
  }
  .row {
    margin: 0px 0px 20px 0px;
    max-width: 100%;

    .form-control {
      max-width: 1000px;
    }
    label.je-form-input-label {
      display: inline;
    }
    select.je-switcher {
      padding-left: 8px;
      margin-bottom: 5px;
      color: #4f4f4f;
      width: 75px;
    }
    input {
      margin: 0px;
    }
  }
  th {
    display: none;
  }
  textarea.je-textarea {
    color: #000000;
  }
}
</style>
